import { render } from "./AccessLandListControl.vue?vue&type=template&id=d2483996&ts=true"
import script from "./AccessLandListControl.vue?vue&type=script&lang=ts"
export * from "./AccessLandListControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__